import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hasOverlay", "children"];
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import { Panel } from 'foundations-components/transitional/components/Panel';
import { jsx as _jsx } from "react/jsx-runtime";
const PanelWithOverlay = _ref => {
  let {
      hasOverlay,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return hasOverlay ? /*#__PURE__*/_jsx(ModalPanel, Object.assign({}, props, {
    children: children
  })) : /*#__PURE__*/_jsx(Panel, Object.assign({}, props, {
    children: children
  }));
};
export default PanelWithOverlay;